import { SystemContext } from '../types';
import { BookingWorld } from './booking-world';
import { BufferstockOnlyWorld } from './bufferstock-only-world';
import { CarOnlyWorld } from './car-only-world';
import { NoBookingWorld } from './no-booking-world';
import { UnifiedWorld } from './unified-world';

const UNIFIED_WORLD = new UnifiedWorld();
const BUFFERSTOCK_ONLY_WORLD = new BufferstockOnlyWorld();
const CAR_ONLY_WORLD = new CarOnlyWorld();
const NO_BOOKING_WORLD = new NoBookingWorld();

/**
 * Wählt die Welt aus den Bestands-Funktionsschaltern. Weder KFZ noch
 * Bufferstock aktiv liefert die No-op-Welt - keine Hintergrund-Verbuchung,
 * kein Fehler.
 * @param ctx Systemkontext mit den Funktionsschaltern carActive und bufferstockActive.
 * @returns Die passende Welt-Instanz (unified, bufferstock-only, car-only oder no-booking).
 */
export function selectWorld(ctx: SystemContext): BookingWorld {
  if (ctx.carActive && ctx.bufferstockActive) {
    return UNIFIED_WORLD;
  }
  if (ctx.bufferstockActive) {
    return BUFFERSTOCK_ONLY_WORLD;
  }
  if (ctx.carActive) {
    return CAR_ONLY_WORLD;
  }
  return NO_BOOKING_WORLD;
}
